import type { ReactNode } from 'react'

import './page-header.css'

export interface PageHeaderProps {
    title: ReactNode
    subtitle?: string
    actions?: ReactNode
}

// Standard page title block: a left-aligned title (with optional subtitle) and
// an optional right-aligned actions slot. Used by every view so the title sits
// in the same place with the same size/weight everywhere.
export const PageHeader = ({ title, subtitle, actions }: PageHeaderProps) => (
    <header className="page-header">
        <div className="page-header__text">
            <h1 className="page-header__title">{title}</h1>
            {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
    </header>
)
